"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setObjectPropByPath = (origin, path, value) => {
    if (path.length === 1) {
        return Object.assign(Object.assign({}, origin), { [path[0]]: value });
    }
    const [currentPropName, ...restOfPath] = path;
    return Object.assign(Object.assign({}, origin), { [currentPropName]: setObjectPropByPath(origin[currentPropName] || {}, restOfPath, value) });
};
exports.default = setObjectPropByPath;
